<template>
  <el-dialog :width="width" class="msg-dialog-body" @close="close"  :visible.sync="isShow" append-to-body :close-on-click-modal="false">
    <div slot="title" class="dialog-footer" >
      <div class="title-view">
        <img v-if="showErrorIcon" src="/static/err-icon.png" class="error-icon" alt="">
        <img v-if="showMsgIcon" src="/static/spyj.png" class="msg-icon" alt="">
        <span class="title-text">{{ title }}</span>
      </div>

    </div>
    <div class="msg-content">
      <slot></slot>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <slot name="footer">

      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "msgDialog",
  props:{
    visible:false,
    title:'',
    showErrorIcon:false,
    showMsgIcon:false,
    width: {
      type:String,
      default:'40%'
    }
  },
  data(){
    return{
      isShow:this.visible
    }
  },
  watch:{
    visible(v){
      this.isShow = v
    }
  },
  methods:{
    close(){
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header{
  padding-left: 16px;
  padding-bottom: 16px;
  .el-dialog__headerbtn .el-dialog__close{
    color: #909399;
    font-size: 30px;
    cursor: pointer;
  }
  .el-dialog__headerbtn .el-dialog__close:hover{
    color: #E8556F;
  }
  .el-dialog__title{
    font-size: 22px;
  }
}
/deep/ .el-dialog{
  border-radius: 5px;
}
/deep/ .el-dialog__title{
  font-size: 30px;
  font-weight: 600;
}
/deep/  .el-dialog__body{
  padding-top: 0px !important;
}
.msg-content{
  width: 100%;
  background: white;
  min-height: 100px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //font-weight: 600;
}
.title-view{
  display: flex;
  align-items: center;
}
.title-text{
  font-size: 20px;
  font-weight: 500;
}
.error-icon{
  margin-right: 10px;
  width: 24px;
  height: 24px;
}
.msg-icon{
  margin-right: 10px;
  width: 25px;
  height: 25px;
}
.dialog-footer{
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/msgDialog.vue